"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_sim__swap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("title", null, "sim-swap-mid"), /*#__PURE__*/React.createElement("g", {
    id: "e6c2e607-d978-4e06-968c-d85a699ede63",
    "data-name": "ICON"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ecee61c5-fa66-4748-bfa9-febc379a8cba",
    "data-name": "Business_ic_mid"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 70,
    width: 36,
    height: 60,
    rx: 6,
    ry: 6,
    fill: "none",
    stroke: "#e60000",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,86h22a6,6,0,0,1,6,6v48a6,6,0,0,1-6,6H108a6,6,0,0,1-1-.08",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#e60000",
    strokeLinejoin: "round",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("g", {
    id: "744ab09f-9720-4de3-bfe2-821deccb882f",
    "data-name": "sim_swap"
  }, /*#__PURE__*/React.createElement("path", {
    id: "4f30e015-7b10-45c1-ace5-d9b4c2dc87a1",
    "data-name": "<Pfad>",
    d: "M110,54v0a12,12,0,0,0-3.52-8.48l-16-16h0A12,12,0,0,0,82,26H46A12,12,0,0,0,34,38V138a12,12,0,0,0,12,12H98a12,12,0,0,0,12-12Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#676767",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "94463db7-ff6e-4f26-b4c7-3c665f9319f2",
    "data-name": "<Pfad>",
    d: "M82,151v3a12,12,0,0,0,12,12h52a12,12,0,0,0,12-12V70a12,12,0,0,0-3.52-8.48l-16-16h0A12,12,0,0,0,130,42H103",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#676767",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))));
}

var _default = ic_sim__swap;
exports.default = _default;